import { createFileRoute } from "@tanstack/react-router"
import { EmbeddedWhatsapp } from "modules/settings/components/integrations/whatsapp"

export const Route = createFileRoute("/_base/_auth/settings/channels/whatsapp/")({
  component: EmbeddedWhatsapp,
})
